<template >
    <div class="flex flex-row overflow-x-auto w-full gap-2 p-2 pb-8">
        <Vimg v-for="img in array" :key="img" :src="img.src" :credit="img.credit" :pagina="img.pagina" class="h-full flex-none"/>
    </div>

</template>
<script setup>
import {defineProps,ref} from 'vue'
import Vimg from './Vimg.vue';

const props = defineProps({
    array:{
        type:Array,
        required:true
    }
})

const array=ref(props.array)

</script>